<template>
  <div class="PcContain" style="overflow: auto;">
    <CommonHeader @searchFun="searchFun"/>
    <!--最近访问-->
    <!-- <div class="recentV" v-if="$route.name=='apps'">
      <div class="recentt" style="margin-left: 10px;width: 1200px;margin: 0 auto">

        <div  class="recent" style="" v-for="(i,dx) in $store.state.recent">
          <div v-if="dx==0" style="width: 45px;font-size: 16px;color: rgb(248, 187, 56);font-weight: 700">最近访问</div>
          <div class="text"></div>
          <a target="_blank" :href="i.uri" class="codeName">{{i.name}}</a>
        </div>

      </div>
    </div> -->
    <div class="layout" :style="{minHeight:totalTip == 'special'?'400px':'600px'}">
      <!-- <keep-alive exclude="contentsTemplate"> -->
        <router-view ref="servicePageSearch"></router-view>
      <!-- </keep-alive> -->
    </div>
    <CommonFooter/>
  </div>
</template>
<script>
import {myMixin} from '@/mixins/tool.js'
import CommonHeader from './commonHeader'
import CommonFooter from './commonFooter'
import {mapState} from "vuex"
import gql from 'graphql-tag'  //引入graphql
export default {
  name: "index",
  mixins: [myMixin],
  components: {CommonHeader, CommonFooter},
  created() {
    document.title = "浙江财经大学一网通办";
  },
  computed:{
    ...mapState(['totalTip'])
  },
mounted() {

},
  methods: {
    searchFun(val) {
      this.$router.push('/workflow/serviceCenter');
      setTimeout(() => {
        this.$refs['servicePageSearch'].toSearch(val);
      }, 100)
    }
  }
}
</script>
<style lang="less">
@import '~@/assets/todoCenter/default/css/taskcenter.less';
</style>
<style>
.recentt{
  flex:0 0 19%;
  display: flex !important;
  align-items: center;
  justify-content: space-between;
}
.recent{
  display: flex !important;
  align-items: center;
}
.text{
  width: 7px;height: 7px;background-color: #2262a8;border-radius: 4px;margin-right: 10px;
}
.recentV{
 background-color: rgb(250, 250, 250);padding: 8px
}
.codeName{
  max-width: 225px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/layout/index.vue